<template>
  <question-card @submit="submit" :disabled="buttonDisabled" :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div>
        <property-address-input
          v-model="questionnaireLead.PropertyAddress"
          :placeholder="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
          :types="!UIComponentData.isFullAddress?['(cities)']:['address']"
          :componentForm="componentForm"
          ref="input"
          required
        />
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';
import PropertyAddressInput from '@/components/ui-kit/PropertyAddressInput.vue';

export default {
  name: 'property-address-step',
  components: {
    QuestionCard,
    PropertyAddressInput,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    buttonDisabled() {
      return this.questionnaireLead.PropertyAddress.length<10;
    },
    componentForm() {
      return {
        locality: 'long_name',
        administrative_area_level_1: 'long_name',
        ...(this.UIComponentData.isFullAddress)
          ? {
            street_number: 'long_name',
            route: 'long_name',
            country: 'short_name',
            postal_code: 'short_name',
          } : {},
      };
    },
  },
  mounted() {
    this.$refs.input.$el.focus();
  },
  created(){
    if(!this.questionnaireLead.PropertyAddress)
      this.$set(this.questionnaireLead, 'PropertyAddress','');
  }
};
</script>
